import { Box } from './box';

export class BoxLarge2023 extends Box
{
  constructor(
      canvas: HTMLCanvasElement,
      svgReference: SVGElement|string,
      options: Object = {})
  {
    const model = {
      boxTop: {
        position: [
            // Front
            -1.093, -1.51,  0.235,
             1.093, -1.51,  0.235,
             1.093,  1.51,  0.235,
            -1.093,  1.51,  0.235,
            // Top
            -1.093,  1.51,  0.235,
             1.093,  1.51,  0.235,
             1.093,  1.51, -0.235,
            -1.093,  1.51, -0.235,
            // Bottom
            -1.093, -1.51, -0.235,
             1.093, -1.51, -0.235,
             1.093, -1.51,  0.235,
            -1.093, -1.51,  0.235,
            // Right
             1.093, -1.51,  0.235,
             1.093, -1.51, -0.235,
             1.093,  1.51, -0.235,
             1.093,  1.51,  0.235,
            // Left
            -1.093, -1.51, -0.235,
            -1.093, -1.51,  0.235,
            -1.093,  1.51,  0.235,
            -1.093,  1.51, -0.235
        ],
        element: [
            // Front
             0,  1,  2,
             0,  2,  3,
            // Top
             4,  5,  6,
             4,  6,  7,
            // Bottom
             8,  9, 10,
             8, 10, 11,
            // Right
            12, 13, 14,
            12, 14, 15,
            // Left
            16, 17, 18,
            16, 18, 19,
        ],
        texture: [
            // Front
            0.194, 0.843,
            0.806, 0.843,
            0.806, 0.157,
            0.194, 0.157,
            // Top
            0.194, 0.157,
            0.806, 0.157,
            0.806, 0.040,
            0.194, 0.040,
            // Bottom
            0.194, 0.960,
            0.806, 0.960,
            0.806, 0.843,
            0.194, 0.843,
            // Right
            0.806, 0.843,
            0.950, 0.843,
            0.950, 0.157,
            0.806, 0.157,
            // Left
            0.050, 0.843,
            0.194, 0.843,
            0.194, 0.157,
            0.050, 0.157
        ],
        svgReference: svgReference,
        updateFrequency: 'regular',
        vertexNormal: [
            // Front
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            // Top
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            // Bottom
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            // Right
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            // Left
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0
        ],
      },
      boxBottom: {
        position: [
            // Back
            -1.093, -1.51, -0.235,
            -1.093,  1.51, -0.235,
             1.093,  1.51, -0.235,
             1.093, -1.51, -0.235
         ],
        element: [
            // Back
             0,  1,  2,
             0,  2,  3,
        ],
        color: [ 0.95, 0.95, 0.95 ],
        vertexNormal: [
            // Front
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
        ],
      }
    };
    super(canvas, model, options);
  }
}
